import { render, staticRenderFns } from "./clientDocuments.vue?vue&type=template&id=ffed6d72&scoped=true&"
import script from "./clientDocuments.vue?vue&type=script&lang=js&"
export * from "./clientDocuments.vue?vue&type=script&lang=js&"
import style0 from "./clientDocuments.vue?vue&type=style&index=0&id=ffed6d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffed6d72",
  null
  
)

export default component.exports